export default __webpack_public_path__ + "static/media/dis4.c129c73c.png";